import React from 'react';
import { LuChevronRight } from 'react-icons/lu';

export default function EquipmentDashboardTables() {
  // Data for the Equipment Register Summary Table
  const equipmentData = [
    { category: 'Kitchen Equipment', total: 22, inService: 20, outOfService: 0, maintenanceDue: 2 },
    { category: 'Refrigeration', total: 12, inService: 11, outOfService: 0, maintenanceDue: 1 },
    { category: 'Front of House', total: 8, inService: 8, outOfService: 0, maintenanceDue: 0 },
    { category: 'Cleaning Equipment', total: 6, inService: 5, outOfService: 1, maintenanceDue: 1 },
    { category: 'Small Appliances', total: 7, inService: 6, outOfService: 0, maintenanceDue: 1 },
    { category: 'Other Equipment', total: 7, inService: 4, outOfService: 1, maintenanceDue: 1 },
  ];

  // Data for the Maintenance Overview Table
  const maintenanceData = [
    { type: 'Planned (Scheduled)', total: 24, completed: 20, dueSoon: 3, overdue: 1, na: 0 },
    { type: 'Preventive', total: 18, completed: 16, dueSoon: 2, overdue: 0, na: 0 },
    { type: 'Corrective', total: 12, completed: 10, dueSoon: 2, overdue: 0, na: 0 },
    { type: 'Statutory Inspections', total: 8, completed: 7, dueSoon: 1, overdue: 0, na: 0 },
  ];

  return (
    <div className="w-full bg-slate-50 p-6 font-sans">
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 max-w-[1600px] mx-auto">
        
        {/* Left Card: Equipment Register Summary */}
        <div className="bg-white border border-slate-100 rounded-2xl p-6 shadow-sm flex flex-col justify-between">
          <div>
            <h2 className="text-base font-bold text-indigo-950 mb-5">
              Equipment Register Summary
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-indigo-50/40 text-[10px] font-bold text-indigo-900/80 tracking-wider">
                    <th className="p-3 rounded-l-lg w-[35%]">CATEGORY</th>
                    <th className="p-3 text-center">TOTAL</th>
                    <th className="p-3 text-center">IN SERVICE</th>
                    <th className="p-3 text-center">OUT OF SERVICE</th>
                    <th className="p-3 text-center rounded-r-lg">MAINTENANCE DUE</th>
                  </tr>
                </thead>
                <tbody className="text-xs font-semibold text-slate-700 divide-y divide-slate-100">
                  {equipmentData.map((row, index) => (
                    <tr key={index} className="hover:bg-slate-50/50 transition-colors">
                      <td className="p-3 font-bold text-slate-800">{row.category}</td>
                      <td className="p-3 text-center font-bold text-slate-900">{row.total}</td>
                      <td className={`p-3 text-center font-bold ${row.inService > 0 ? 'text-emerald-600' : 'text-slate-400'}`}>{row.inService}</td>
                      <td className={`p-3 text-center font-bold ${row.outOfService > 0 ? 'text-rose-600' : 'text-slate-400'}`}>{row.outOfService}</td>
                      <td className={`p-3 text-center font-bold ${row.maintenanceDue > 0 ? 'text-orange-500' : 'text-indigo-950'}`}>{row.maintenanceDue}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <button className="mt-6 flex items-center justify-center gap-1.5 w-full text-xs font-bold text-blue-600 hover:text-blue-700 transition-colors py-2">
            <span>View full equipment register</span>
            <LuChevronRight className="text-sm stroke-[2.5]" />
          </button>
        </div>

        {/* Right Card: Maintenance Overview */}
        <div className="bg-white border border-slate-100 rounded-2xl p-6 shadow-sm flex flex-col justify-between">
          <div>
            <h2 className="text-base font-bold text-indigo-950 mb-5">
              Maintenance Overview
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-indigo-50/40 text-[10px] font-bold text-indigo-900/80 tracking-wider">
                    <th className="p-3 rounded-l-lg w-[35%]">TYPE</th>
                    <th className="p-3 text-center">TOTAL</th>
                    <th className="p-3 text-center">COMPLETED</th>
                    <th className="p-3 text-center">DUE SOON</th>
                    <th className="p-3 text-center">OVERDUE</th>
                    <th className="p-3 text-center rounded-r-lg">NOT APPLICABLE</th>
                  </tr>
                </thead>
                <tbody className="text-xs font-semibold text-slate-700 divide-y divide-slate-100">
                  {maintenanceData.map((row, index) => (
                    <tr key={index} className="hover:bg-slate-50/50 transition-colors">
                      <td className="p-3 font-bold text-slate-800">{row.type}</td>
                      <td className="p-3 text-center font-bold text-slate-900">{row.total}</td>
                      <td className={`p-3 text-center font-bold ${row.completed > 0 ? 'text-emerald-600' : 'text-slate-400'}`}>{row.completed}</td>
                      <td className={`p-3 text-center font-bold ${row.dueSoon > 0 ? 'text-orange-500' : 'text-slate-400'}`}>{row.dueSoon}</td>
                      <td className={`p-3 text-center font-bold ${row.overdue > 0 ? 'text-rose-600' : 'text-slate-400'}`}>{row.overdue}</td>
                      <td className="p-3 text-center font-bold text-indigo-950">{row.na}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <button className="mt-6 flex items-center justify-center gap-1.5 w-full text-xs font-bold text-blue-600 hover:text-blue-700 transition-colors py-2">
            <span>View full maintenance log</span>
            <LuChevronRight className="text-sm stroke-[2.5]" />
          </button>
        </div>

      </div>
    </div>
  );
}
